// common
import TabsView from 'common/components/TabsView';

// screen
import { ChangePasswordTab, RolesAssignmentTab, UserInfoTab } from 'modules/account/detail/tabs';
import { TabsDataProvider } from 'modules/account/detail/dataContext';
import { useTabsData } from 'modules/account/detail/hooks/useTabsData';

interface Props {
  viewOnly?: boolean;
}

// Inner component that uses the context
const AccountDetailContent = () => {
  const { viewOnly } = useTabsData();

  return (
    <TabsView
      tabLabels={
        viewOnly
          ? ['account.userInfo', 'account.roleAssignment']
          : ['account.userInfo', 'account.changePassword', 'account.roleAssignment']
      }
      tabContents={
        viewOnly
          ? [<UserInfoTab />, <RolesAssignmentTab />]
          : [<UserInfoTab />, <ChangePasswordTab />, <RolesAssignmentTab />]
      }
    />
  );
};

// Main component that provides the context
const AccountDetailPage = ({ viewOnly }: Props) => {
  return (
    <TabsDataProvider viewOnly={viewOnly}>
      <AccountDetailContent />
    </TabsDataProvider>
  );
};

export default AccountDetailPage;
